import React from 'react';
import '../../styles/global.scss';

const Loading = () => {
  return (
    <div className={'componentWrapper'}>
      <div className={['loading', 'loader'].join(' ')}></div>
    </div>
  );
};

export default Loading;
